import {
  AssetDetailsFormStep,
  StaticFieldToDisplayType,
} from "#src/batteries-included-components/Panels/FormPanels/AssetDetailsFormPanel/AssetDetailsFormStep";
import { useListCustomAttributes } from "#src/components/hooks/adapters/useCustomAttributes";
import { useMultiStepFormContext } from "#src/hooks/useMultiStepForm";
import {
  AssetType,
  AttributeDataType,
  EquipmentSchema,
  Resources,
} from "@validereinc/domain";
import { Equipment } from "@validereinc/domain-controllers";
import React from "react";

const { EquipmentStatusOptions } = Equipment.view;

const EquipmentDetailsFormStep = () => {
  // Form steps logic
  const { getStep } = useMultiStepFormContext();
  const prevStep = getStep(1);
  const prevStepValues = prevStep?.getValues();

  // Queries:
  const customAttributesQuery = useListCustomAttributes({
    filters: { entity_type: AssetType.EQUIPMENT },
  });

  const customAttributes = customAttributesQuery.data?.data ?? [];

  const staticFieldsToDisplay: StaticFieldToDisplayType[] = [
    {
      display_name: "Status",
      field_name: EquipmentSchema.keyof().Enum.status,
      data_type: AttributeDataType.PICK_LIST,
      pick_list_values: EquipmentStatusOptions.map((option) => ({
        id: option.value,
        name: option.label,
      })),
      is_required: true,
    },
    {
      field_name: EquipmentSchema.keyof().Enum.effective_date,
      display_name: "Effective Date",
      is_required: true,
      data_type: AttributeDataType.DATE,
    },
    {
      field_name: "coordinations",
      display_name: "Coordinations",
      is_required: false,
      data_type: AttributeDataType.GEO_POINT,
    },
    ...customAttributes
      .filter((custom_attribute) =>
        custom_attribute.entity_subtypes
          ? custom_attribute.entity_subtypes.includes(
              prevStepValues?.type_id as string
            )
          : true
      )
      .sort((a, b) => Number(b.is_required) - Number(a.is_required))
      .map((custom_attribute) => {
        return {
          ...custom_attribute,
          field_name: `custom_attributes.${custom_attribute.field_name}`,
        } as typeof custom_attribute;
      }),
  ];

  return (
    <AssetDetailsFormStep
      resourceType={Resources.EQUIPMENT}
      staticFieldsToDisplay={staticFieldsToDisplay}
    />
  );
};

export default EquipmentDetailsFormStep;
